const splitLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

const formatSplitLabel = (splitIndex: number | undefined) => {
  const letter = splitLetters[splitIndex ?? -1] ?? '-';

  return {
    index: splitIndex,
    label: letter,
    title: `Split ${letter}`,
  };
};

export { formatSplitLabel };
